<template>
  <div class="detailed_report_form" :style="screenHeight">
    <div class="fixed_search" style="height: 100px">
      <div class="fixed_search_input">
        <Input v-model="customerName" placeholder="请输入客户名称" title="客户名称"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="callerNum" placeholder="请输入主叫号码" title="主叫号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="calleeNum" placeholder="请输入被叫号码" title="被叫号码"/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="rwName" placeholder="请选择AI流程" clearable title="AI流程">
          <Option v-for="(option,index) in aiFlow" :key="index" :value="option.rwName">{{option.rwName}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="callType" placeholder="请选择呼叫类型" clearable title="呼叫类型">
          <Option v-for="(option,index) in callTypes" :key="index" :value="option.id">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="contionState" placeholder="请选择通话状态" clearable title="通话状态">
          <Option v-for="(option, index) in hangUpTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Input v-model="pstnNumber" placeholder="请输入热线号码" title="热线号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="firstQueueNum" placeholder="请输入技能组号码" title="技能组号码"/>
      </div>
      <!--<div class="fixed_search_input">
        <Select v-model="customerLevel" multiple placeholder="请选择客户等级">
          <Option v-for="(option,index) in customerLevels" :key="index" :value="option.label">{{option.label}}</Option>
        </Select>
      </div>-->
      <div class="fixed_search_input">
        <Input v-model="focusName" placeholder="请输入关注点" title="关注点"/>
      </div>
      <div class="fixed_search_input fixed_search_multiple" v-if="hasRecognize">
        <Select v-model="callStatus" multiple placeholder="请选择未接通原因">
          <Option v-for="(option,index) in callStatusList" :key="index" :value="option.tName" :title="option.tDescr">{{option.tName}}</Option>
        </Select>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="starEndTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" @click="exportExcel('a_5-1','AI管理=>AI通话记录=>导出')" v-if="roleList['a_5-1']">导出</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>正在加载中... </Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection" @sort-change="sortChange" @cell-click="reportCallScreen" :cell-class-name="showColor" @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip="true" :type="item.type" :key="index" :fixed="item.fixed" :sortable="item.key === 'focuses'?false:'custom'" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150" v-if="contentList.length>0 && (roleList['a_5-4'] || roleList['a_5-2'] || roleList['a_5-3'])" align="center">
          <template slot-scope="scope">
            <el-button @click="playCallRecord(scope.row.recordFile)" :disabled="!scope.row.recordFile" type="text" size="small" v-show="roleList['a_5-4']">播放</el-button>
            <el-button disabled v-if="!scope.row.recordFile" style="margin-left: 0px;" type="text" size="small" v-show="roleList['a_5-2']">下载</el-button>
            <a :href="baseURL+'common/downloadFile.json?type=0&addr='+scope.row.recordFile" target="_blank" v-else class="down_file_a" v-show="roleList['a_5-2']">下载</a>
            <el-button @click="searchDetail(scope.row.callUuid)" type="text" size="small" v-show="roleList['a_5-3']">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size="pageSize" :current="currentPage" :page-size-opts="pageSizeList" show-total show-sizer @on-change="changeCurrent" @on-page-size-change="changeSize"></Page>
      <div style="padding-top: 2px">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px">页</div>
    </div>
    <AICallDetail @closeCallDetail="closeFlowDetail" :showCallDetailPop="openFlowDetail" :callUuid="callUuid"></AICallDetail>
    <callDetailPop  @closeCallDetail="closeCallDetail" :showCallDetailPop="showCallDetailPop" :AICall="true" :callUuid="callUuid"></callDetailPop>
    <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
    <publicPop @closePublicPop="closePublicPop" :showPublicPop="showPublicPop" :popSign="popSign"></publicPop>
    <publicDialerPage @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer" :callUpPhone="callUpPhone"></publicDialerPage>
    <PublicSendMessage @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage" :callUpPhone="callUpPhone"></PublicSendMessage>
  </div>
</template>

<script>
  import {publicFunClass} from "@/components/js/PublicFunClass";
  import {customerPublicBtn} from "@/components/js/CustomerPublicBtn";
  import publicPop from '@/components/customerMange/PublicPop.vue'
  import PublicSendMessage from "@/components/login/PublicSendMessage";
  import PublicDialerPage from "@/components/login/PublicDialerPage";
  import AICallDetail from "./AICallDetail";
  import CallDetailPop from "../statisticsReportForm/detailedReportForm/CallDetailPop";
  import PlayMusicPop from "../statisticsReportForm/detailedReportForm/PlayMusicPop";

  export default {
    name: "AICallRecordListing",
    mixins:[publicFunClass,customerPublicBtn],
    components:{
      PlayMusicPop,
      CallDetailPop,
      AICallDetail,
      PublicDialerPage,
      PublicSendMessage,
      publicPop
    },
    props: {
      pageCode: String
    },
    data() {
      return {
        showPageCount:0,
        roleList: JSON.parse(localStorage.getItem('roleList')),
        screenHeight:{height:''},
        tableHeight: 600,
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        pageSize:20,
        speedChangePage:1,
        musicUrl:'',
        spinShow:false,
        showRecordFile:false,
        recordFile:'',
        showCallDetailPop:false,
        openFlowDetail:false,
        popSign:'通话记录导出',
        checkAll:false,
        checkIds:[],
        tableClass:true,
        journalType:'null',
        menuId:'null',
        callUuid:'',
        configInfo:JSON.parse(localStorage.getItem('configInfo')),
        orderField:'',
        orderRule:'',

        showPublicPop:false,

        fieldList: [
          {type: 'selection', width: 50, fixed: true},
          {width: 120, fixed: true, key: 'customerName', 'title': '客户名称'},
          {width: 120, fixed: true, key: 'callerNum', 'title': '主叫号码'},
          {width: 120, fixed: true, key: 'calleeNum', 'title': '被叫号码'},
          {width: 200, key: 'rwName', 'title': 'AI流程'},
          {width: 200, key: 'callType', 'title': '呼叫类型'},
          {width: 200, key: 'callState', 'title': '通话状态'},
          /*{width: 200, key: 'customerLevel', 'title': '客户意向'},*/
          {width: 200, key: 'pstnNumber', 'title': '热线号码'},
          {width: 200, key: 'firstQueueNum', 'title': '技能组号码'},
          {width: 200, key: 'startTime', 'title': '开始时间'},
          {width: 200, key: 'callTime', 'title': '通话时长'},
          {width: 200, key: 'waitTime', 'title': '等待时长'},
          {width: 200, key: 'allTime', 'title': '总时长'},
          {width: 200, key: 'count', 'title': '对话轮次'},
          {width: 200, key: 'tagName', 'title': '分类标签'},
          {width: 200, key: 'focuses', 'title': '关注点'},
        ],
        contentList:[],

        //search
        contionState:'',
        hangUpTypeList:[{'id':'0','name':'未接通'},{'id':'1','name':'已接通'}],
        customerName:'',
        firstQueueNum:'',
        pstnNumber:'',
        callerNum:'',
        calleeNum:'',
        rwName:'',
        aiFlow:[],
        callType:'',
        focusName:'',
        callTypes:[{'id':'1','name':'呼入'},{'id':'2','name':'手动呼出'},{'id':'3','name':'自动呼出'}],
        customerLevel:[],
        customerLevels:[{id:'1',label:'A'},{id:'2',label:'B'},{id:'3',label:'C'},{id:'4',label:'D'},{id:'5',label:'E'},{id:'6',label:'F'}],
        callStatus:[],
        callStatusList:[],
        starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
        editable:false,
        hasRecognize:false,
        queryParam: null,
      }
    },
    methods:{
      initSearch() {
        this.spinShow=true;
        this.$emit("closeVn",true);
        let that=this;
        let param={
          orderField:this.orderField,
          orderRule:this.orderRule,
          contionState:this.contionState,
          callType:this.callType,
          callStatus:this.callStatus.toString(),
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          customerName:this.customerName,
          starEndTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
          callerNum:this.callerNum,
          calleeNum:this.calleeNum,
          pstnNumber:this.pstnNumber,
          focusName:this.focusName,
          firstQueueNum:this.firstQueueNum,
          rwName:this.rwName,
          journalType:"null",
          menuId:"null",
        };
        this.queryParam = param;
        this.$http.post("AI/CallLog/queryAICallLogs",param) .then(function (res) {
          let result=res.data;
          that.spinShow=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.checkIds=[];
          that.contentList=res.data.obj.list.content;
          that.total=res.data.obj.list.totalSize;
          let timeShowStyle=that.configInfo.timeShowStyle;
          if(timeShowStyle=='0'){
            for(let i=0;i< that.contentList.length;i++){
              that.contentList[i].callTime=that.contentList[i].callTimeSecond;
              that.contentList[i].IVR=that.contentList[i].IVRSecond;
              that.contentList[i].waitTime=that.contentList[i].waitTimeSecond;
              that.contentList[i].allTime=that.contentList[i].allTimeSecond;
            }
          }
        })

      },
      exportExcel(menuId, journalType) {
        this.journalType=journalType
        this.menuId=menuId
        this.showPublicPop=true
      },
      reset() {
        this.customerName=''
        this.calleeNum = ''
        this.callerNum = ''
        this.pstnNumber=''
        this.rwName=''
        this.firstQueueNum=''
        this.contionState=''
        this.callType=''
        this.focusName=''
        this.customerLevel=[]
        this.callStatus=[]
        this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')]
      },
      getCustomName(name) {
        if (name === 'customerName') {
          return 'customer_name'
        }else if (name === 'callerNum') {
          return 'caller_num'
        }else if (name === 'calleeNum') {
          return 'callee_num'
        }else if (name === 'rwName') {
          return 'rw_name'
        }else if (name === 'callType') {
          return 'call_type'
        }else if (name === 'callState') {
          return 'call_lasts_time'
        }else if (name === 'pstnNumber') {
          return 'dnis'
        }else if (name === 'firstQueueNum') {
          return 'first_queue_num'
        }else if (name === 'startTime') {
          return 'start_time'
        }else if (name === 'callTime') {
          return 'call_time'
        }else if (name === 'waitTime') {
          return 'wait_time'
        }else if (name === 'allTime') {
          return 'all_time'
        }else if (name === 'count') {
          return 'count'
        }else if (name === 'warnToneName') {
          return 'warn_tone_name'
        }else if (name === 'asrWarnToneTxt') {
          return 'asr_warn_tone_txt'
        }else if (name === 'tagName') {
          return 'tag_name'
        }
      },
      sortChange(event) {
        if (event && event.order) {
          this.orderField = this.getCustomName(event.prop);
          this.orderRule = event.order == 'descending' ? 'desc' : 'asc';
        } else {
          this.orderField=''
          this.orderRule=''
        }
        this.initSearch()
      },
      searchDetail(callUuid) {
        this.callUuid = callUuid
        this.showCallDetailPop=true
      },
      closeCallDetail() {
        this.showCallDetailPop=false
      },
      closeFlowDetail() {
        this.openFlowDetail = false
      },
      closePublicPop(flag, operateStyle, popSign) {
        this.showPublicPop = false
        let param = {
          ids:this.checkIds.toString(),
          journalType:this.journalType+"按选中结果"+popSign,
          menuId:this.menuId,
          type:operateStyle
        }
        if (flag) {
          if (operateStyle === '0') {
            if (this.checkIds.length === 0) {
              this.$Modal.info({
                title:'提示',
                content:'请选择要导出的数据'
              });
              return false;
            }
          }
          if (operateStyle === '1') {
            if (this.contentList.length === 0) {
              this.$Modal.info({
                title:'提示',
                content:'当前没有可导出的数据'
              })
              return false
            }
            if(!this.queryParam){
              this.$Modal.info({
                title:'提示',
                content:"请点击查询后再导出"
              });
              return false;
            }
            delete this.queryParam["pageNum"];
            delete this.queryParam["pageSize"];

            this.$set(this.queryParam, 'type', operateStyle);
            this.$set(this.queryParam, 'journalType', this.journalType+"按搜索结果"+popSign);
            this.$set(this.queryParam, 'menuId', this.menuId);
            param = this.queryParam;
          }
          this.$Loading.start()
          this.operateExcelExport(param,"AI/CallLog/exportCallrecords.json")
        }
      },
      closeRecordfile:function(){
        this.showRecordFile=false;
      },
      initCallStatus() {
        let param = {menuId:'a_5-1', journalType: '查询通话状态标识'}
        let that = this
        this.$http.post('AI/CallLog/queryCallStatus',param).then(res=>{
          let response = res.data
          if (response.flag !== '666') {
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return
          }
          that.callStatusList = response.obj
        })
      },
      playCallRecord(recordFile) {
        if(!recordFile){
          this.$Modal.info({
            title:'提示',
            content:"录音文件不存在"
          });
          return false;
        }
        this.showRecordFile=true;
        this.recordFile=this.baseImgURL+recordFile;
      },
    },
    created() {
      this.screenHeight.height = this.mountHeight(91)
      let clientHeight = document.documentElement.clientHeight
      this.tableHeight=clientHeight-235
      //判断是否含有识别功能
      let recognize = this.configInfo.aiRecognize
      if (recognize && (recognize + '' === '1' || recognize + '' === '2')) {
        this.hasRecognize = true
        let json = {width: 200,key:'warnToneName','title':'未接通原因'}
        if (this.fieldList.indexOf(json) < 0) {
          this.fieldList.push(json)
          let json2 = {width: 200,key:'asrWarnToneTxt','title':'未接通内容'}
          this.fieldList.push(json2)
        }
      }
    },
    destroyed() {
      this.$emit('closeVn',true)
    },
    watch: {
      pageCode() {
        if (this.pageCode == 'a_5' && this.showPageCount == 0) {
          this.$emit('openVn', true)
          this.showPageCount++
          this.handleScroll()
          this.getAIWorkFlow()
          this.initCallStatus()
        }
      }
    }
  };
</script>

<style>
  .el-table th.gutter{
   display: table-cell!important;
  }
  .el-table .el-table__body-wrapper::-webkit-scrollbar{
   width:auto;
   width:15px;
   height:8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/aiManager/AICallRecordListing.vue